var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4915 0.666992H5.50817C2.47484 0.666992 0.666504 2.47533 0.666504 5.50866V12.4837C0.666504 15.5253 2.47484 17.3337 5.50817 17.3337H12.4832C15.5165 17.3337 17.3248 15.5253 17.3248 12.492V5.50866C17.3332 2.47533 15.5248 0.666992 12.4915 0.666992ZM6.05817 8.15033C6.29984 7.90866 6.69984 7.90866 6.9415 8.15033L8.37484 9.58366V4.42533C8.37484 4.08366 8.65817 3.80033 8.99984 3.80033C9.3415 3.80033 9.62484 4.08366 9.62484 4.42533V9.58366L11.0582 8.15033C11.2998 7.90866 11.6998 7.90866 11.9415 8.15033C12.1832 8.39199 12.1832 8.79199 11.9415 9.03366L9.4415 11.5337C9.38317 11.592 9.3165 11.6337 9.2415 11.667C9.1665 11.7003 9.08317 11.717 8.99984 11.717C8.9165 11.717 8.8415 11.7003 8.75817 11.667C8.68317 11.6337 8.6165 11.592 8.55817 11.5337L6.05817 9.03366C5.8165 8.79199 5.8165 8.40033 6.05817 8.15033ZM14.1998 13.3503C12.5248 13.9087 10.7665 14.192 8.99984 14.192C7.23317 14.192 5.47484 13.9087 3.79984 13.3503C3.47484 13.242 3.29984 12.8837 3.40817 12.5587C3.5165 12.2337 3.8665 12.0503 4.19984 12.167C7.29984 13.2003 10.7082 13.2003 13.8082 12.167C14.1332 12.0587 14.4915 12.2337 14.5998 12.5587C14.6998 12.892 14.5248 13.242 14.1998 13.3503Z",
    fill: "url(#paint0_linear_7516_2999)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7516_2999",
    x1: 17.3249,
    y1: 0.666992,
    x2: 0.658199,
    y2: 17.3254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56B8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F8FB9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/downIcon.69113c3be0f665f5d3dd8e075eaa682c.svg";
export { ForwardRef as ReactComponent };